import React, { Fragment, useCallback } from 'react';
import PermissionContext from 'contexts/permissionContext';
import { PermissionAware } from 'core';
import cx from 'classnames';
import _ from 'lodash';

interface PermissionCheckerProps {
  permissionAware: PermissionAware;
  renderOtherwise?: any;
  className?: string;
}

const PermissionChecker: React.FC<
  React.PropsWithChildren<PermissionCheckerProps>
> = (props) => {
  const children = React.Children.map(props.children, (child) => {
    if (!React.isValidElement(child)) {
      return child;
    }
    return React.cloneElement(
      child,
      _.omitBy(
        {
          ...child.props,
          ..._.omit(props, ['permissionAware', 'renderOtherwise', 'children']),
          className: cx(child.props.className, props.className)
        },
        _.isEmpty
      )
    );
  });

  const renderOtherwise = useCallback(() => {
    if (props.renderOtherwise) {
      return props.renderOtherwise();
    }
    return undefined;
  }, [props]);

  return (
    <PermissionContext.Consumer>
      {(permissionContext) => {
        if (!permissionContext) {
          return <Fragment />;
        }
        return (
          <Fragment>
            {props.permissionAware.visible(permissionContext)
              ? children
              : renderOtherwise()}
          </Fragment>
        );
      }}
    </PermissionContext.Consumer>
  );
};

export default PermissionChecker;
